import {Icon} from '@iconify/react';
import {Box} from '@mui/material';
import PropTypes from 'prop-types';

export default function AppIcon({name, ...props}) {
  return <Box component={Icon} icon={name} {...props} />;
}

AppIcon.propTypes = {
  name: PropTypes.string.isRequired,
};
